import $ from 'jquery';

export class FormError extends Error {

    /**
     * FormError constructor.
     *
     * @param {string|null} message
     * @param {jQuery|HTMLElement} input
     */
    constructor(message, input) {
        super(message);

        this.input = input;
        this.errorElementSelector = '';
    }

    /**
     * Set the css selector of the element with the error message
     *
     * @param selector
     */
    setErrorElementSelector(selector) {
        this.errorElementSelector = selector;
    }

    /**
     * Get the html element with the error message
     *
     * @return {jQuery|HTMLElement}
     */
    getErrorElement() {
        const name = this.input.attr('name');

        if (this.errorElementSelector === '') {
            this.errorElementSelector = `.c-input-error-message[data-form-error-message][data-input-name="${name}"]`;
        }

        return $(this.errorElementSelector);
    }

    /**
     * Show the error
     */
    show() {
        const error = this.getErrorElement();

        if (error) {
            error.css({
                'opacity': 1,
                'max-height': 'none',
                'width': 'auto'
            });
        }
    }

}

export class FormEmptyError extends FormError {

    show() {
        const name = this.input.attr('name');
        this.setErrorElementSelector(`.c-input-empty-message[data-form-error-message][data-input-name="${name}"]`);

        super.show();
    }

}